hot = window.Handsontable # shortcut

# start with the base autocomplete editor
AutocompleteEditor = hot.editors.AutocompleteEditor
BetterAutocompleteEditor = AutocompleteEditor.prototype.extend()

# most of this is copied from handsontable.full.js, with a few modifications

# override the open function to not filter the options at first
BetterAutocompleteEditor.prototype.open = () ->
    that = this

    hot.editors.HandsontableEditor.prototype.open.apply(this, arguments)

    @TEXTAREA.style.visibility = 'visible'
    @focus()

    # small hack to prevent vertical scrollbar causing a horizontal scrollbar
    @htContainer.style.overflow = 'hidden'

    choicesListHot = @htEditor.getInstance()

    choicesListHot.updateSettings
        colWidths: [Handsontable.Dom.outerWidth(@TEXTAREA) - 2]
        afterRenderer: (TD, row, col, prop, value) ->
            caseSensitive = @getCellMeta(row, col).filteringCaseSensitive is true

            if value
                if caseSensitive
                    indexOfMatch = value.indexOf(@query)
                else
                    indexOfMatch = value.toLowerCase().indexOf(that.query.toLowerCase())

                if indexOfMatch isnt -1
                    match = value.substr(indexOfMatch, that.query.length)
                    TD.innerHTML = value.replace(match, '<strong>' + match + '</strong>')

    that.instance._registerTimeout setTimeout () ->
        that.queryChoices('') # don't filter the list until the user starts typing

        # small hack to prevent vertical scrollbar causing a horizontal scrollbar
        that.htContainer.style.overflow = 'auto'

# override updateChoicesList to use @query (set in queryChoices), instead
# of getting the input value again, and to select the input contents when the
# editor is opened (makes it easier to start typing a fresh autocomplete query)
BetterAutocompleteEditor.prototype.updateChoicesList = (choices) ->
    filteringCaseSensitive = @cellProperties.filteringCaseSensitive is true
    orderByRelevance = AutocompleteEditor.sortByRelevance(@query, choices, filteringCaseSensitive)

    if @cellProperties.filter isnt false
        sorted = []
        for i in orderByRelevance
            sorted.push(choices[i])
        highlightIndex = 0
        choices = sorted
    else
        highlightIndex = orderByRelevance[0]

    @choices = choices

    @htEditor.loadData(Handsontable.helper.pivot([choices]))
    @htEditor.updateSettings({ height: @getDropdownHeight() })

    if @cellProperties.strict is true
        @highlightBestMatchingChoice(highlightIndex)

    @instance.listen()
    @TEXTAREA.focus()

    # this allows us to select the entire value of the input on open
    if @query is ''
        endPos = @getValue().length
        Handsontable.Dom.setCaretPosition(@TEXTAREA, 0, (if endPos isnt 0 then endPos else undefined))

# register it
hot.editors.registerEditor 'betterAutocomplete', BetterAutocompleteEditor
